import { getLocale } from "../runtime";

const sv_secountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sverige`
};

const secountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_secountry(inputs)
	return "seCountry";
};

export { secountry as "seCountry" };